import { Component, OnInit } from '@angular/core';
import { URLSearchParams } from '@angular/http';
import { Subscription }   from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';

import { AuthService } from '../../../../providers/auth.service';
import { SharedHackService } from '../../shared/services/shared-hack.service';
import { ScreenTalentService } from '../screen-talent.service';

import { default as swal } from 'sweetalert2';


export class TestsComponent implements OnInit {

	public tests: any[];
	public selectedTestsStatus: string = 'live';
	public state: any = {
		offset: 0,
		limit: 10,
		loading: false,
		hasMore: true,
		count: 0
	};

	constructor(
		private authService: AuthService,
		private sharedHackService: SharedHackService,
		private screenTalentService: ScreenTalentService) { }

	// Lifecycle Events
	public ngOnInit(): void {
		this.getExternalTests(this.selectedTestsStatus, false);
	}

	// Events
	public onViewTestClick(test: any): void {
		this.screenTalentService.emitEventAction({ component: 'screen-talent', action: 'viewTest', data: test });
	}

	public onAddNewTestClick(): void {
		this.screenTalentService.emitEventAction({ component: 'screen-talent', action: 'changeView', data: 'test-add' });
	}

	public onTestStatusTypeChange(statusType: string): void {
		this.selectedTestsStatus = statusType;
		this.getExternalTests(this.selectedTestsStatus, false);
	}

	public onTestIsEditChange(test: any, event: any): void {
		event.stopPropagation();
		if (test.EditInProgress) {
			return;
		}
		test.EditInProgress = true;
		let queryParams = new URLSearchParams();
		queryParams.append('statuses[]', 'completed');
		queryParams.append('statuses[]', 'started');
		this.sharedHackService.getExternalTestInvitationsCount(String(this.authService.userId), test.id, queryParams).subscribe(
			(stats) => {
				let completedCount = stats.total;

				if (completedCount > 0) {
					test.EditInProgress = false;
					// there are completed invitations so edit is unavaible
					swal({
						title: '',
						text: 'Test cannot be edited because it\'s already taken by candidates.',
						type: 'warning',
						showCancelButton: true,
						confirmButtonColor: '#E06160',
						confirmButtonText: 'Duplicate',
						cancelButtonText: 'Cancel',
						showLoaderOnConfirm: true,
						allowOutsideClick: false,
						allowEscapeKey: false,
						reverseButtons: true,
						preConfirm: () => {
							return this.sharedHackService.getHack(String(this.authService.userId), test.hack_id)
								.flatMap((hack: any) => {
									let testData = {
										title: test.title + ' [DUPLICATE]',
										time: hack.time,
										type: test.type,
										roles: [],
										custom_path: test.custom_path
									};
									test.roles.forEach((role) => {
										testData.roles.push(role.id);
									});

									return this.sharedHackService.postExternalTest(String(this.authService.userId), testData)
										.flatMap((newTest: any) => {
											return this.duplicateTestChallenges(newTest, hack)
												.flatMap((res: any) => {
													// make sure to return the new test
													return Observable.of(newTest);
												});
										});
								})
								.toPromise();
						}
					}).then((response) => {
						this.screenTalentService.emitEventAction({ component: 'screen-talent', action: 'testCreated', data: response });
						test.EditInProgress = false;
					}, () => {
						test.EditInProgress = false;
					});
				} else {
					let queryParamsPending = new URLSearchParams();
					queryParamsPending.set('status', 'pending');
					this.sharedHackService.getExternalTestInvitationsCount(String(this.authService.userId), test.id, queryParamsPending).subscribe(
						(pendingStats) => {
							let pendingCount = pendingStats.total;

							// check if there are pending invitations
							if (pendingCount > 0) {
								swal({
									title: '',
									text: 'Editing this Test will invalidate any invitation links previously shared',
									type: 'warning',
									showCancelButton: true,
									confirmButtonColor: '#E06160',
									confirmButtonText: 'Edit',
									cancelButtonText: 'Cancel',
									allowOutsideClick: false,
									allowEscapeKey: false,
									reverseButtons: true
								}).then(() => {
									this.sharedHackService.doInProgressExternalTest(String(this.authService.userId), test.id)
									.flatMap((res: any) => {
										return this.sharedHackService.deleteExternalTestInvitations(String(this.authService.userId), test.id);
									})
									.subscribe(
										(res: any) => {
											setTimeout(() => {
												this.screenTalentService.emitEventAction({ component: 'screen-talent', action: 'editTest', data: test });
												test.EditInProgress = false;
											}, 1000);
										}
									);
								}, () => {
									test.EditInProgress = false;
								});
							} else {
								this.sharedHackService.doInProgressExternalTest(String(this.authService.userId), test.id).subscribe(
									(resp) => {
										test.EditInProgress = false;
										this.screenTalentService.emitEventAction({ component: 'screen-talent', action: 'editTest', data: test });
										test.EditInProgress = false;
									}
								);
							}
						}
					);
				}
			}
		);
	}

	public onTestIsArchivedChange(test: any, event: any): void {
		this.state.loading = true;
		event.stopPropagation();

		this.sharedHackService.archiveExternalTest(String(this.authService.userId), test.id, !test.is_archived).subscribe(
			(resp) => {
				// remove external test
				let idx = this.tests.findIndex((item) => item.id === test.id);
				if (idx !== -1) {
					this.tests.splice(idx, 1);
					if (this.state.offset !== 0) {
						this.state.offset -= 1;
					}
				}
				this.state.loading = false;
			}
		);
	}

	// Service Call
	private getExternalTests(selectedTestsStatus: string, concat?: boolean): void {
		this.state.loading = true;
		this.state.offset = concat ? this.state.offset : 0;
		let params: URLSearchParams = new URLSearchParams();

		if (selectedTestsStatus === 'live') {
			params.set('is_archived', '0');
		} else if (selectedTestsStatus === 'archived') {
			params.set('is_archived', '1');
		}

		params.set('order', 'desc');
		params.set('limit', this.state.limit);
		params.set('offset', this.state.offset);

		if (!concat) {
			this.tests = null;
		}

		this.sharedHackService.getExternalTests(String(this.authService.userId), params).subscribe(
			(tests) => {
				this.tests = concat ? this.tests.concat(tests) : tests;
				this.state.offset += tests.length;
				this.state.hasMore = tests.length === this.state.limit ? true : false;

				this.state.loading = false;
			}
		);
	}

	// Helpers

	private duplicateTestChallenges(newTest: any, oldHack: any): Observable<any> {
		let observables = [];
		oldHack.knowledge_test_questions.forEach((question) => {
			let questionData = {
				copy_source_id: question.id,
			};
			observables.push(this.sharedHackService.postKnwoledgeTestQuestionLibrary(String(this.authService.userId), newTest.hack_id, questionData));
		});
		oldHack.coding_challenges.forEach((challenge) => {
			let codingData = {
				copy_source_id: challenge.id,
			};
			observables.push(this.sharedHackService.postCodingChallenge(String(this.authService.userId), newTest.hack_id, codingData));
		});
		oldHack.project_upload_challenges.forEach((challenge) => {
			let projectUploadData = {
				copy_source_id: challenge.id,
			};
			observables.push(this.sharedHackService.postProjectUploadChallenge(String(this.authService.userId), newTest.hack_id, projectUploadData));
		});
		oldHack.hackaroot_challenges.forEach((challenge) => {
			let hackarootData = {
				copy_source_id: challenge.id,
			};
			observables.push(this.sharedHackService.postHackarootChallenge(String(this.authService.userId), newTest.hack_id, hackarootData));
		});
		oldHack.project_challenges.forEach((challenge) => {
			let projectData = {
				copy_source_id: challenge.id,
			};
			observables.push(this.sharedHackService.postProjectChallenge(String(this.authService.userId), newTest.hack_id, projectData));
		});
		oldHack.diagram_challenges.forEach((challenge) => {
			let diagramData = {
				copy_source_id: challenge.id,
			};
			observables.push(this.sharedHackService.postDiagramChallenge(String(this.authService.userId), newTest.hack_id, diagramData));
		});
		oldHack.web_challenges.forEach((challenge) => {
			let webData = {
				copy_source_id: challenge.id,
			};
			observables.push(this.sharedHackService.postWebChallenge(String(this.authService.userId), newTest.hack_id, webData));
		});

		return Observable.forkJoin(observables);
	}

	private onLoadMoreClick(): void {
		this.getExternalTests(this.selectedTestsStatus, true);
	}
static ctorParameters() { return [ { type: AuthService }, { type: SharedHackService }, { type: ScreenTalentService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/screen-talent/tests/tests.component.ts